import { platformApi } from '@/apis';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { addDays, startOfDay } from 'date-fns';

export function useIntelligenceItem(code, defaultValue) {
  const queryKey = ['intelligence', code, defaultValue];
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey,
    queryFn: ({ signal }) => {
      if (code === 'new') {
        return {
          expiryDate: startOfDay(addDays(new Date(), 10)),
          ...defaultValue,
        };
      }

      return platformApi.get(`intelligence/${code}`, { signal }).json();
    },
    enabled: !!code,
    staleTime: 1000 * 60 * 60,
  });

  return {
    query,
    cancel: () => queryClient.cancelQueries({ queryKey }),
  };
}
